import { axiosInstance } from "../../../../Services";

export const fetchCardComments = async (cardId, page = 1) => {
  try {
    const res = await axiosInstance.get(
      `/mmhboard/cards/comment/${cardId}?page=${page}`
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const addCardComment = async (cardId, formData) => {
  try {
    const res = await axiosInstance.post(
      `/mmhboard/cards/comment/${cardId}`,
      formData,
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const uploadCommentAttachment = async (cardId, formData) => {
  try {
    const res = await axiosInstance.post(
      `/mmhboard/cards/attachment/${cardId}`,
      formData,
    );
    return res;
  } catch (error) {
    throw error;
  }
};
